import getUnixTime from './get-unix-time';

export { getUnixTime };

export default getUnixTime;
